// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_qz-5";
export var filledCircle = "_qz-4";
export var historyEntry = "_qz-3";
export var messageSideLeft = "_qz-1";
export var messageSideRight = "_qz-2";
export var orderTrackingCarouselWrapper = "_qz-6";
export var orderTrackingInfoContainer = "_qz-0";